import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchFeaturedProfessionals,
} from "../store/profesionales/thunks.ts";

type RootState = {
  general?: {
    componentLoading?: boolean;
  };
  register?: {
    skillsList?: any[];
  };
  profile?: {
    usersInJurisdiction?: any[];
  };
};

const useProfesionalesBootstrap = () => {
  const dispatch = useDispatch<any>();
  const hasFetchedRef = useRef(false);

  const jurisdictionsLoaded = useSelector(
    (state: RootState) => !!state.profile?.usersInJurisdiction?.length
  );
  const isLoading = useSelector((state: RootState) => state.general?.componentLoading ?? false);

  useEffect(() => {
    if (hasFetchedRef.current) return;
    if (jurisdictionsLoaded) return;

    hasFetchedRef.current = true;
    dispatch(fetchFeaturedProfessionals());
  }, [dispatch, jurisdictionsLoaded]);

  return {
    isLoading,
    jurisdictionsLoaded,
  };
};

export default useProfesionalesBootstrap;

